import { DepartmentNameEnum } from "../shared/interfaces";

export interface ActiveUser {
  id: string,
  name: string,
  email: string,
  role: 'admin' | 'user' | 'Ing. de Campo' | 'Tecnico Campo'
}

// export enum DepartmentNameEnum {
//   wellWhisper = '33909508-729a-11ef-b5c1-c9abfae58c0d',
//   rig = 'rig',
//   tanks = 'tanks',
//   gasMeasure = 'gasMeasure',
// }

export enum BaseStatusEntityEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  DELETED = 'DELETED',
  LOCKED = 'LOCKED',
}

export interface Sprint {
  id: string,
  code: string,
  name: string,
  status: BaseStatusEntityEnum,
}

export interface Backlog {
  id: string,
  code: string,
  name: string,
  status: BaseStatusEntityEnum,
  sprints: Sprint[],
}

export interface Project {
  id: string,
  code: string,
  name: string,
  status: BaseStatusEntityEnum,
  backlogs: Backlog[],
}

export interface ActiveDepartment {
  id: string,
  code: string,
  name: string,
  status: BaseStatusEntityEnum,
  projects: Project[],
}

export interface Subtask {
  id: string,
  status: BaseStatusEntityEnum,
  resourceLink: string,
  process: string,
  errors: string[],
}

export interface File {
  id: string,
  status: BaseStatusEntityEnum,
  detail: string,
  url_link: string,
  subtask: Subtask,
}

export interface TeamMember {
  id: string,
  name: string,
  email: string,
}

export interface ErrorDetail {
  type: string;
  field: string;
  message: string;
}

export interface UserDetail {
  email: string;
  name: string;
}

export interface OriginFlow {
  id: string;
  name: string;
}

export interface TaskList {
  id: string;
  name: string;
  description: string | null;
  state: string;
  errors: ErrorDetail[];
  originFiles: any[] | null;
  originFlow: OriginFlow;
  createdAt: string;
  updatedAt: string;
  user: UserDetail;
}

export interface ListOfActivities {
  id: string,
  location: string,
  status: string,
  completedAt: Date,
  activityType: string,
  opeStatus: string,
  cardPath: string,
}

export interface ListOfLocationsToAnalyst {
  id: string,
  name: string,
  status: string,
  completedAt: Date,
  pot: string,
  activityType: string,
  opeStatus: string,
  activities: ListOfActivities[],
  hasCardsToAnalyze: boolean,
}

export interface reportFilters{
  startDate?: string,
  endDate?: string,
  projectId?: string,
  activeReport?: ReportInterface,
}

export interface gerenciaTecnicaState {
  activeDepartmentId?: DepartmentNameEnum | undefined,
  activeProjectId?: string,
  showMenu: boolean,
  activeUser?: ActiveUser,
  loading: boolean,
  showUserMenu: boolean,
  activeDepartment: ActiveDepartment | undefined,
  usersList: ActiveUser[],
  uploadingStep?: string,
  taskList?: TaskList[],
  notifications?: ToastProps[],
  listOfLocation?: ListOfLocationsToAnalyst[],
  activitiesWithCarts?: any[],
  cardsWithActivities?: any[],
  taskValidations?: ValidationItem[],
  locations?: any[],
  users?: User[],
  totalActivities: number;
  reportsList?: ReportInterface[];
  reportWithData?: any[];
  reportFilters?: reportFilters;
  locationListFilter: any;
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface OptionValidation {
  id: string;
  value: string;
}

export interface ValidationItem {
  id: string;
  name: string;
  validationType: validationTypeEnum;
  required: boolean;
  options: OptionValidation[];
  homologation: string[];
}

export interface ToastProps {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
  duration?: number;
}

export interface OriginalFlowUploadInterface{
  id: string,
  name: string,
  typeOfActivities: string[],
}

export const originalFlowUploadV1 = [
  { "id": "5929f816-89c5-4828-9ea3-4ff54be008e3", "name": "Echometer", typeOfActivities: ['Nivel Dinámico', 'Nivel Estático', 'Carta Dinagrafica', 'Estudio Completo', 'Revisión'] },
  { "id": "63624ddd-41c7-45df-8d12-805eb644268c", "name": "Leuter Digital", typeOfActivities: ['Carta Leuter', 'Revisión'] },
  { "id": "a6da0d56-ca00-11ef-9bba-712c8b335d3b", "name": "Report BCP", typeOfActivities: ['Nivel Dinámico', 'Nivel Estático','Revisión'] },
  { "id": "f63fbc29-2a0b-11f0-bbe6-00505652cca1", "name": "Revision", typeOfActivities: ['Revisión','Arranque'] },
]

export const originalFlowUpload = [
  { "id": "5929f816-89c5-4828-9ea3-4ff54be008e3", "name": "Echometer", typeOfActivities: ['Nivel Dinámico', 'Nivel Estático', 'Carta Dinagrafica', 'Estudio Completo', 'Revisión'] },
  { "id": "63624ddd-41c7-45df-8d12-805eb644268c", "name": "Leuter Digital", typeOfActivities: ['Carta Leuter', 'Revisión'] },
  { "id": "a6da0d56-ca00-11ef-9bba-712c8b335d3b", "name": "Report BCP", typeOfActivities: ['Nivel Dinámico', 'Nivel Estático','Revisión'] },
  { "id": "f63fbc29-2a0b-11f0-bbe6-00505652cca1", "name": "Revision", typeOfActivities: ['Revisión','Arranque'] },
]

export const allowTests = [
  { typeOfActivity: 'Estudio Completo', carta: ['si'], nivel: ['si'], pp: ['si', 'no'], pv: ['si', 'no']},
  { typeOfActivity: 'Nivel Dinámico', carta: ['no'], nivel: ['si'], pp: ['no','si'], pv: ['no'] },
  { typeOfActivity: 'Nivel Estático', carta: ['no'], nivel: ['si'], pp: ['no','si'], pv: ['no'] },
  { typeOfActivity: 'Carta Dinagrafica', carta: ['si'], nivel: ['no'], pp: ['no','si'], pv: ['no','si']},
  { typeOfActivity: 'Carta Leuter', carta: ['si'], nivel: ['no'], pp: ['no','si'], pv: ['no','si']},
  { typeOfActivity: 'Revisión', carta: ['no'], nivel: ['no'], pp: ['no','si'], pv: ['no']}
]

export const allowWellOperationStates = [
  {initialState:'Aportando', finalState:['Aportando','IT','Observación','Sin Producción']},
  {initialState:'Operando', finalState:['Operando','IT','Observación']},
  {initialState:'IT', finalState:['IT','Observación','Recolocado','Restaurado','Sin Producción']},
  {initialState:'Sin Aporte', finalState:['Restaurado','IT','Sin Producción','Sin Aporte','Observación']},
  {initialState:'Observación', finalState:['Observación','Sin Aporte','Restaurado','Sin Producción']},
  {initialState:'Sin Acceso', finalState:['Sin Acceso']},
]

export enum validationTypeEnum {
  date = 'date',
  string = 'string',
  number = 'number',
  list = 'list',
  boolean = 'boolean',
  fraction = 'fraction',
}

export interface ReportInterface {
  id: string,
  code: string,
  name: string,
  description: string,
  department: string,
  version: string,
  updated: string,
  releaseDate?: string,
  config: any,
  type: 'table-dynamic' | 'custom'
}